export const STATUS_PENDING_PAYMENT = 'pending_payment';
export const STATUS_PAID = 'paid';
export const STATUS_COMPLETE = 'complete';
export const STATUS_EXPIRED = 'expired';
export const STATUS_CANCELED = 'canceled';
export const STATUS_APPROVED = 'approved';

export type OrderStatusType =
  | typeof STATUS_PENDING_PAYMENT
  | typeof STATUS_PAID
  | typeof STATUS_COMPLETE
  | typeof STATUS_EXPIRED
  | typeof STATUS_CANCELED
  | typeof STATUS_APPROVED;
